<template>
    <ion-page class="ion-page" id="main">
        <default-header>
            <template v-slot:start>
                <ion-buttons slot="start">
                    <header-menu/>
                </ion-buttons>
            </template>
<!--            <template>-->
<!--                <ion-searchbar-->
<!--                        placeholder="Contactpersonen doorzoeken"-->
<!--                        color="light"-->
<!--                        animated-->
<!--                        debounce="500"-->
<!--                        @ionChange="searchChanged"-->
<!--                />-->
<!--            </template>-->
        </default-header>
        <ion-content fullscreen>
            <flash-messages/>
            <contacts :search="search"/>
        </ion-content>
    </ion-page>
</template>
<script>
    import Contacts from "../../components/contacts/Contacts";
    import DefaultHeader from "../../components/nav/DefaultHeader";
    import FlashMessages from "../../components/ui-elements/FlashMessages";
    import HeaderMenu from "../../components/nav/HeaderMenu";

    export default {
        components: {HeaderMenu, FlashMessages, DefaultHeader, Contacts},
        data() {
            return {
                search: undefined,
            }
        },
        methods: {
            searchChanged(search) {
                this.search = search;
            },
        },
    }
</script>
